module.exports = __webpack_public_path__ + "assets/img/ig-2.addd5191.png";